import {useFetchPages} from "../../features/page/pageApi";
import HeaderPageItem from "./HeaderPageItem";

type Props = {
    onClick: () => void
}

const HeaderPageList = ({onClick}: Props) => {
    const {data:paginatedPages} = useFetchPages();

    if (!paginatedPages) {
        return (<></>)
    }

    const pagesToDisplay = paginatedPages.data.filter((page) => page.header);

    return (
        <>
            {pagesToDisplay.map((page) => (
                <HeaderPageItem key={page.id} page={page} onClick={onClick}/>
            ))}
        </>
    )
}

export default HeaderPageList;
